import React from 'react'
import { v4 as uuidv4 } from 'uuid'

import {
  ClientPricingItemOutputDto,
  ClientPricingItemTypeEnum,
  CurrencyEnum,
  NestedItemObjectDataOutputDto,
  ServiceProviderCategoryEnum,
  TaxIdentifierEnum,
} from '../../../../../lib/graphql'
import TagClientPricingItem from '../../../../templates/house/house-services/house-service/tag-client-pricing-item/TagClientPricingItem'

const ServiceProvisionExtraContent = ({
  clientPricingItemId,
  nestedItemsObjectData,
}: {
  clientPricingItemId: string
  nestedItemsObjectData: NestedItemObjectDataOutputDto[]
}) => {
  if (nestedItemsObjectData.length === 0) {
    return null
  }
  return (
    <>
      {nestedItemsObjectData.map((nestedItem) => {
        const formattedClientPricingItem: ClientPricingItemOutputDto = {
          _id: uuidv4(),
          category: ServiceProviderCategoryEnum.BATCH_PROVISIONS,
          objectData: {
            label: nestedItem.label,
            description: nestedItem.description,
            prices: [],
            taxIdentifier: TaxIdentifierEnum.FRA,
            currencyArea: {
              currency: CurrencyEnum.EUR,
              vatRates: [],
            }, // TODO-AHL: should use client pricing item currency area
          },
          option: {},
          priceOption: {
            quantity: nestedItem.quantity,
          },
          type: ClientPricingItemTypeEnum.SERVICE_PROVISION,
        }
        return (
          <TagClientPricingItem
            key={`${clientPricingItemId}.${nestedItem.objectId ?? nestedItem.type}`}
            clientPricingItem={formattedClientPricingItem}
            showTotalPrice={false}
            hasRoundedPrice={false}
            styleContent={{
              border: '1px solid var(--clr-grey-300)',
              marginBottom: '10px',
            }}
          />
        )
      })}
    </>
  )
}

export default ServiceProvisionExtraContent
